import { useContext } from 'react'
import ServerResponseContext from '../context/ServerResponseProvider'

const useServerResponse = () => {
    return useContext(ServerResponseContext)
}

export default useServerResponse